import { useMemo } from 'react';
import * as Yup from 'yup';


export const useFormConfigLayoutValidation = () => {
    const FormConfigLayoutValidationYup = useMemo(() => {
        return (
            Yup.object().shape({
                qtdeSetores: Yup.string().required('Quantidade de Setores é obrigatório.'),
                qtdeProcessos: Yup.string().required('Quantidade de Processos é obrigatório.'),
                intervaloAudioPedidoNovoMs: Yup.number()
                    .required('Intervalo do áudio é obrigatório.')
                    .oneOf(
                        [5000, 10000, 15000, 20000, 30000, 40000, 50000, 60000, 120000, 180000, 240000, 300000],
                        'Selecione um intervalo válido.',
                    ),
            })
        )
    }, [])
    return {
        FormConfigLayoutValidationYup,
    }
}
